/**
 * Browser geolocation API wrapper
 */

export async function requestBrowserLocation(timeout = 10000) {
    if (!('geolocation' in navigator)) {
        throw new Error('Geolocation not available in this browser');
    }

    const position = await new Promise((resolve, reject) => {
        navigator.geolocation.getCurrentPosition(resolve, reject, {
            timeout: timeout,
            maximumAge: 300000, // Cache for 5 minutes
            enableHighAccuracy: false // Faster response
        });
    });

    return {
        lat: position.coords.latitude,
        lon: position.coords.longitude
    };
}
